<div mat-dialog-title class="dialog-title">
    <h2>Select Facilities</h2>
    <div class="actions">
        <button mat-button color="lightGreen" type="button" (click)="selectAll()">Select All</button>
        <button mat-button color="lightGreen" type="button" (click)="selectNone()">Select None</button>
    </div>
</div>
<div mat-dialog-content class="dialog-content">
    <div class="buttons">
        <mat-checkbox
        *ngFor="let facility of facilities"
        [checked]="!!facility.selected"
        color="lightGreen"
        (change)="facility.selected = !facility.selected"
        >{{ facility.name }}</mat-checkbox
        >
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button color="lightGreen" type="submit" (click)="done()">Done</button>
</div>